/* HM Metalworks motion layer v3 — hero entrance + scroll reveals. Additive, safe to remove. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var SCROLL_SELECTORS = [
    '.main-content .index__column',
    '.main-content .icon__column',
    '.main-content .rte > h1',
    '.main-content .rte > h2',
    '.main-content .rte > h3',
    '.main-content .rte > p',
    '.main-content .rte > ul',
    '.main-content .rte > ol',
    '.main-content .rte img'
  ].join(',');

  function init() {
    // Hero entrance: staggered rise-in, delayed past first paint so it reads as intentional
    document.querySelectorAll('.main-content .hero__content').forEach(function (hero) {
      hero.classList.add('hm-hero-seq');
    });

    // Scroll reveals: fire when the element is genuinely in view, not at first pixel
    var els = Array.prototype.slice.call(document.querySelectorAll(SCROLL_SELECTORS)).filter(function (el) {
      return !el.closest('.hm-hero-seq') && !el.classList.contains('hm-reveal') && !el.closest('.hm-reveal');
    });
    if (!els.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('hm-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -15% 0px', threshold: 0.12 }
    );

    var parents = [];
    var counts = [];
    els.forEach(function (el) {
      el.classList.add('hm-reveal');
      var parent = el.parentElement || document.body;
      var idx = parents.indexOf(parent);
      if (idx === -1) {
        parents.push(parent);
        counts.push(0);
        idx = parents.length - 1;
      }
      el.style.setProperty('--hm-delay', Math.min(counts[idx] * 0.12, 0.6) + 's');
      counts[idx] += 1;
      io.observe(el);
    });

    // Failsafe: never leave content hidden if the observer misses something in view
    setTimeout(function () {
      els.forEach(function (el) {
        if (!el.classList.contains('hm-in')) {
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('hm-in');
        }
      });
    }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
